<app-header></app-header>

<header class="slidermain menu-page text-white login-page">
    <img src="assets/img/productb1.jpg" alt="news" class="w-100">
  <div class="container-fluid">
     <div class="mask-content-v-center text-left log-card"> 

        <div class="col-md-9 mx-auto">
           <div class="row align-items-center login-box no-gutters">
             <div class="col-md-5">
                <div class="">
                    <div class="card-body login-card">
                        <h5 class="card-title">{{ 'login.customer_login' | translate }}</h5>
                        <p>{{ 'login.h_1' | translate }}</p>
                        <div class="form-signin">
                            <form #lrlogFrm="ngForm" (ngSubmit)="loginFormSubmit(lrlogFrm)" autocomplete="off">
                            <div class="form-group">
                                 <label for="">{{ 'login.email_mobile' | translate }}</label>
                                 <input class="form-control" autocomplete="off" name="useremail" ngModel required>
                            </div>
                            <div class="form-group">
                                <label for=""> {{ 'login.password' | translate }} </label>
                                <input type="password" class="form-control" name="password" 
                                required minlength="5" autocomplete="off" ngModel> 
                            </div>
                            <div class="row">
                                <div class="col-md-12 text-left">
                                    <div class="custom-control custom-checkbox mb-1 mb-md-3">
                                        <input type="checkbox" class="custom-control-input" id="customCheck1">
                                        <label class="custom-control-label" for="customCheck1">{{ 'login.r_password' | translate }}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 text-center">
                                <span *ngIf="showLang == 'en' " class="errcls errclsmain">{{errmsg}}</span>
                                <span *ngIf="showLang == 'ar' " class="errcls errclsmain">{{errmsg_ar}}</span>
                            </div>
                            <button  type="submit" class="btn btn-lg btn-primary orderonline">
                                <i class="fas fa-sign-in-alt"></i>  {{ 'login.signin' | translate }}
                                <span *ngIf="isLoading">
                                    <i class="fas fa-circle-notch fa-spin"></i>
                                </span> 
                            </button>
                            <a class="forgotpswd" href="forgot-password"> {{ 'login.f_password' | translate }} </a>
                            <hr>
                            <p class="log-text">{{ 'login.not_mem' | translate }} <a href="register"> {{ 'login.signup' | translate }} </a></p>
                        </form>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-md-7 image-sec">
             <img class="img-fluid w-100" src="assets/img/login-side-img.jpg" alt="">
         </div>
     </div>
 </div>
</div>
</div>
</header>